import { useDispatch } from "react-redux";
import { addSimilarMovies } from "../store/slices/moviesSlice";
import { useEffect, useCallback } from "react";
import { API_OPTIONS } from "../utils/constants";

const useSimilarMovies = (movieId: string | undefined) => {
  const dispatch = useDispatch();

  const getSimilarMovies = useCallback(async () => {
    if (!movieId) return;
    try {
      const data = await fetch(
        `https://api.themoviedb.org/3/movie/${movieId}/similar?language=en-US&page=1`,
        API_OPTIONS
      );
      const json = await data.json();
      dispatch(addSimilarMovies(json.results));
    } catch (error) {
      console.error("Error fetching similar movies:", error);
    }
  }, [movieId, dispatch]);

  useEffect(() => {
    getSimilarMovies();
  }, [getSimilarMovies]);
};

export default useSimilarMovies;
